import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CourseType } from "../../../types/Course";

const initialState: CourseType = {
    id: "",
    description: "",
    duration: 0,
    name: "",
    status: false,
    idDepartament: "",
    idUniversity: "",
    idFaculty: "",
    idPlan:'',
    idKnowledgeSubDomain:'',
    idKnowledgeDomain:'',
    code:"",

};
export const courseSlice = createSlice({
    name: "courseForm",
    initialState,
    reducers: {
        setUpdateCourseData: (
            state, action: PayloadAction<CourseType>,
        ) => {
            return { ...state, ...action.payload };
        },
        resetUpdateCourseData: (
            state,
        ) => {
            return initialState
        }
    }
});
export const { setUpdateCourseData,resetUpdateCourseData } = courseSlice.actions;
export default courseSlice.reducer;